import * as types from '../../constants/event/drawItemEventConstants';

export const drawItemEventListRequest = ({
  page,
  pageLength,
  searchString,
  callback,
  error,
}) => ({
  type: types.DRAW_ITEM_EVENT_LIST_REQUEST,
  page,
  pageLength,
  searchString,
  callback,
  error,
});

export const drawItemEventCreateRequest = ({
  title,
  tokenType,
  price,
  purchaseLimit,
  descImage,
  beginAt,
  endAt,
  reward,
  callback,
  error,
}) => ({
  type: types.DRAW_ITEM_EVENT_CREATE_REQUEST,
  title,
  tokenType,
  price,
  purchaseLimit,
  descImage,
  beginAt,
  endAt,
  reward,
  callback,
  error,
});

export const drawItemEventInfoDetailRequest = ({
  drawItemNo,
  callback,
  error,
}) => ({
  type: types.DRAW_ITEM_EVENT_INFO_REQUEST,
  drawItemNo,
  callback,
  error,
});

export const drawItemEventLogInfoRequest = ({
  page,
  pageLength,
  searchType,
  searchString,
  drawItemNo,
  callback,
  error,
}) => ({
  type: types.DRAW_ITEM_EVENT_LOG_INFO_REQUEST,
  page,
  pageLength,
  searchType,
  searchString,
  drawItemNo,
  callback,
  error,
});

export const drawItemEventRemoveRequest = ({
  drawItemNo,
  callback,
  error,
}) => ({
  type: types.DRAW_ITEM_EVENT_REMOVE_REQUEST,
  drawItemNo,
  callback,
  error,
});

export const drawItemEventInfoUpdateRequest = ({
  drawItemNo,
  title,
  tokenType,
  price,
  purchaseLimit,
  descImage,
  beginAt,
  endAt,
  reward,
  callback,
  error,
}) => ({
  type: types.DRAW_ITEM_EVENT_UPDATE_REQUEST,
  drawItemNo,
  title,
  tokenType,
  price,
  purchaseLimit,
  descImage,
  beginAt,
  endAt,
  reward,
  callback,
  error,
});
